import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "EnrolmentExport" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  class: "EnrolmentExportLabel"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EnrolmentExportModal = _resolveComponent("EnrolmentExportModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "NavigatorButton EnrolmentExportButton",
      title: "Export enrolments",
      disabled: !_ctx.canExport,
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.onExportButtonClicked()), ["stop"]))
    }, [
      _cache[1] || (_cache[1] = _createElementVNode("i", { class: "lnr-launch EnrolmentExportButtonIcon" }, null, -1 /* CACHED */)),
      (_ctx.buttonLabel)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.buttonLabel), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ], 8 /* PROPS */, _hoisted_2),
    (_ctx.isExportModalShown)
      ? (_openBlock(), _createBlock(_component_EnrolmentExportModal, {
          key: 0,
          onHideModal: _ctx.hideModal,
          exportOptions: _ctx.exportOptions,
          enrolments: _ctx.enrolments
        }, null, 8 /* PROPS */, ["onHideModal", "exportOptions", "enrolments"]))
      : _createCommentVNode("v-if", true)
  ]))
}